import {
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonButton,
  IonText,
} from "@ionic/react";
import { cafeOutline } from "ionicons/icons";
import React, { useState } from "react";
import "./CoffeeControlChart.css";

function CoffeeControlChart() {
  const [showModal, setShowModal] = useState(false);

  return (
    <IonItem className="ion-hide-sm-down">
      <IonIcon icon={cafeOutline} slot="start" className="ion-icon" />
      <IonLabel className="ion-text-wrap">
        Coffee Prices Anomaly Detection
      </IonLabel>

      <IonModal
        isOpen={showModal}
        className="ion-modal-popup"
        backdropDismiss="false"
      >
        <IonText className="ion-justify-content-center ion-align-items-center ion-margin">
          <br />
          <b> Coffee Prices Anomaly Detection </b>
          <br />
          <p>
            The first version of this project was building a quality control
            chart for the Marine Depot Maintenance Command during my senior year
            of high school. I monitored cost abnormalities for marine equipment.
            Due to the confidentiality of this project, I updated it with data
            on prices for Arabica and Robusta coffee beans. In the demo, I
            created tabbed web application using <code> R Shiny </code> - the
            first tab ("Updated QCC") has an improved UI and automatically
            updates based on input where as the second tab ("Original QCC")
            closely mirrors my version 1 from high school.{" "}
          </p>

          <a
            href="https://cameronlowdata.shinyapps.io/CoffeeControlChart/"
            target="_blank"
            rel="noreferrer"
          >
            Click here to see the web app on a new page.
          </a>
          <br />
          <IonButton className="ion-button" onClick={() => setShowModal(false)}>
            Close
          </IonButton>

          <iframe
            src="https://cameronlowdata.shinyapps.io/CoffeeControlChart/"
            name="iframe_a"
            height="500px"
            width="100%"
            title="Iframe Example"
          ></iframe>

          <br />
        </IonText>
      </IonModal>

      <IonButton className="ion-button" onClick={() => setShowModal(true)}>
        Show
      </IonButton>
    </IonItem>
  );
}

export default CoffeeControlChart;
